import { generateRandomID } from './random'

export const FRONTEND_ID = (() => {
  let value = localStorage.getItem('frontendId')
  if (value === null) {
    value = generateRandomID()
    localStorage.setItem('frontendId', value)
  }

  return value
})()
